<template>
  <v-row no-gutters>
    <v-col v-if="permissions && permissions.view && params && params.data && !params.data.is_duplicate">
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <SecondaryButton
            @click="view"
            v-on="on"
            v-bind="attrs"
            x-small
            btnClass="mr-2 rounded"
            icon="mdi-eye"
            iconClass=""
          >
          </SecondaryButton>
        </template>
        <span>View</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      permissions: this.$permissions.getPermission("order"),
    };
  },
  methods: {
    view() {
      this.params.context.parentComponent.getOrderDetails(this.params.data);
    },
  },
};
</script>
